
/**
 *Created by jmmartinez on 18/03/19
 * v.1.1  22/03/2019 Añadido nivelonModificarDatosCargadosonAntesCargarDatos
 * v.1.2  01/04/2019 Modificado render para mostrar tabs sólo si hay definidos campos de búsqueda.
 * v.1.3  04/04/2019 Añadida detección de tecla de conmutacion Busqueda/resultado.
 * v.1.4  05/04/2019 Añadida ref para llamar explicitamente función buscar de FormularioGridBusqueda
 * v.1.5  08/04/2019 Añadida propiedad postObject en gridConfig para pasar al post. Cuando pasa este objeto y className es undefined, es una llamada directa.
 * v.1.6  01/05/2019 Corregido error que iba incrementando los campos de busqueda duplicados.
 * v.1.7  13/05/2019 Uso de getFiltroFromCampo.
 *                   Cambios para que se haga la busqueda inicial
 * v.1.8  15/05/2019 Cambiado el envio de intervalso para usar ISO
 * v.1.9  24/05/2019 Cambiado comportamiento en Load: cargar siempre filtros iniciales y luego los de búsqueda.
 *                   Eliminados parámentros de carga inicial.
 * v.1.10 29/05/209  Subdivision de Refrescar y LoadDatos para el caso de Analisis DataTable
 * v 1.11 30/05/2019 Añadida propiedad showBusqueda
 * v.1.12 05/06/209  Modificados criterios de carga y setState en LoadDatos
 *                   Correcciones menores: size por length
 * v.1.13 25/07/2019 En LoadDAtos añadido un filtrado de condiciones de campos Check para eliminar los valor===0, y así se interprete el desactivado como TODOS.
 * v.1.14 09/09/2019 Añadido paginaActual al state e iniciado con props.paginaActual para indicarla desde el padre.
 *                    En DidMount, ahora se calcula el offset de la pagina actual para poder indicarla desde el padre.
 *                    Creado evento onPageChanged para que el padre (Formulario) pueda monitorizar el cambio de página
 *                    Creado evento onDatosBusquedaChanged para que el padre (Formulario) pueda monitorizar el cambio de opciones de búsqueda
 * v.1.15 12/09/2019  Correcciones para no mostrarpaginador en Análisis:
 *                      En onRefreshData, en Datos de análisis en formato DataTable, en loadDAtos, todasPáginas a true.
 *                      Protegidas las llamadas a callbackTodosDatosCargados con una comprobacion de existencia previa.
 *                      En LoadDatos, en Analisis normal y AnalissiDataTable, en setstate de todasPaginas, añadido datos: datos para que aparezcan los datos en el grid.
 * v.1.16 30/09/2019 En renderOnlyGrid, añadida la condicion !showAcciones para evitar un error en el caso: ShowAllAcciones= false y ShowAcciones= null
 * v.1.17 01/10/2019 Añadido en state: elementoSeleccionado para poder metérselo a FormularioBotonera
 *                   Creadas las funciones asignarShowAllAcciones y asignarShowAcciones para asignar la gestión de acciones.
 *                   Añadidas propiedades botonesAdicionales y onBotonAdicionalClick con informacion de gridConfig en llamada a FormularioBotones
 * v.1.18 02/10/2019 En ComponentWillReceiveProps, para ver si ha cambiado configGrid usamos la funcion compararObjetos, ya q cambios en filtroFijo no los detectaba el !==
 *                   En ComponentWillReceiveProps, el refreshData sólo se llama en determinados cambios para evitar llamadas de más-
 *                   En state añadimos filtroFijoCArgado, que únicamente se modifica en loadDatos. (GridConfig se modifica en algun sitio que no tenemos controlado)
 *                   Eliminadas llamadas asignarShowAllAcciones y asignarShowAcciones ya que se asignan directamente tomandolos únicamente del gridConfig.
 *                   Eliminados showAllAcciones y showAcciones del state. Ahora se leen directamente de props.gridConfig
 *                   En ComponentWill, para ver si ha cambiado el filtroFijo se pasa a usar compararArrays
 * v.1.19 07/10/2019 Usando el nuevo exportarPdfLocal
 * v.1.20 09/10/2019 Añadimos propiedad nombreSvg.
 *                   En exportarPdfLocal comprobamos si hay nombreSvg para llamar a exportarPdfLocal o exportarPdfLocalUI
 * v.1.21 10/10/2019 Llamada a la nueva funcion exportarPdfLocalEmpresaSvg
 *                   Nueva propiedad empresa con los datos de la empresa para el encabezado
 *                   Modificado para showAllAcciones y showAcciones del gridConfig.
 * v.1.22 14/10/2019 En la generación de pdfs locales, se aplican los datos después de añadirles el pie usando la función  calcularDatosConPie
 *                   En la generación de pdfs locales usamos calcularDatosConPdfCampo para copiar el contenido de la columna que quitamos debajo de la columna elegida.
 *                   En la generación de pdfs locales usamos calcularColumnasSinPdfCampo para quitar la columna .
 * v.1.23 15/10/2019 Dentro de grdiConfig, nueva propiedad con la configuracion del pdf si es distinta del standard.ç
 *                   Nueva propiedad datosBusqueda para inicializar los campos de búsqueda al volver.
 *                   Eliminada llamada a onDatosCargados en CARGA DE ANALISIS DATATABLE CON UI. Reutilizamos este evento para guardar los datos preparados en el padre (Formulario)
 *                   Nueva propiedad infoDatosInicial con los datos necesarios para no tener que recargar el grid desde la bdd
 *                   Modificado ComponentDidMount para no cargar los datos si ya vienen preparados del padre.
 * v.1.24 28/10/2019 Modificado onRefreshData y loadDatos para tener en cuenta la paginacion en caso de carga total.
 *                   Modificado DidMount para la carga desde InfoDatos.
 * v.1.25 29/10/2019 Uso de la propiedad showBuscador de gridConfig
 * v.1.26 30/10/2019 Añadida propiedad elementoSeleccionado, para reseleccionar un elemento al volver al grid.
 *                   Añadidas propiedades valorBuscador y onValorBuscadorCambiado.
 * v.1.27 04/11/2019 Uso de gridConfig.variablesPDF en la nueva llamada de exportarPdfLocalEmpresaSvg
 * v.1.28 05/11/2019 En loadDatos, en el caso de la carga de AnalisisUI, se añade la llamada al evento onDatosCargados(datosDataTable).
 * v.1.29 08/11/2019 Añadido método exportarExcelLocal
 * v.1.30 11/11/2019 Añadida propiedad elementoConfig
 *                   Añadido método onRowModificada
 *                   Añadidos parámetros de llamada a GridPaginado: editable y onRowModificada.
 * v.1.31 12/11/2019 Añadida llamada callbackTodosDatosCargados en método load en el caso Restful.
 * v.1.32 20/11/2019 Distincion en loadDatos para cuando recibimos en tipo JPA saber que los datos vienen directamente en el response y no en .lo
 *                   Añadida propiedad onModificarDatosCargados para modificar los datos una vez recibidos pero antes de ser mostrados en el grid.
 * v.1.33 28/01/2020 Añadido evento onAntesCargarDatos para modificar el filtro que se envía en Load antes de enviarlo.
 * v.1.34 25/02/2020 Añadida condicion de existencia de elementoConfig en varios puntos.
 * v.1.35 27/02/2020 En LoadDatos añadida la condicion de  gridConfig.elementosPorPagina > 0 para calcular numPaginas = numTotalDatos / gridConfig.elementosPorPagina;
 *                   En filtrarDatos si numElementos >0 filtramos, si no devolvemos el original
 * v.1.36 02/03/2020 Añadida propiedad onAntesGuardar, para modificar los objetos antes de guardarlos en un grid editable.
 *                   Añadido evento onNuevoElemento para crear el elemento nuevo de la nueva fila.
 * v.1.37 03/03/2020 Añadimos el parámetro callback a las funciones  onRowModificada y GuardarRow
 * v.1.38 04/03/2020 En la funcion onSelectedRow llamamos a this.setState sólo si no es editable.
 * v.1.39 06/03/2020 Añadida en la llamada a GridPaginado de la propiedad tipoGrid para elegir cual de los dos usamos.
 * v.1.40 10/03/2020 Eliminado campo estadoRow en funcion guardarRow.
 * v.1.41 14/03/2020 Modificado guardarRow para añadir los nuevos elementos y para modificar los existentes.
 * v.1.42 16/03/2020 Añadida llamada a onAntesCargarDatos dentro de loadDatos.
 * v.1.43 20/03/2020 Añadido paso de propiedad elementoConfig a GridPaginado en funciones renderTabs y renderOnlyGrid
 * v.1.44 23/03/2020 En renderOnlyGrid, el elementoConfig se obtiene de props y no de state
 * v.1.45 24/03/2020 Quitada la codición gridConfig.editable en RenderOnlyGrid para mostrar los botones de accion
 * v.1.46 30/03/2020 Cargamos la lista de elementos para los combos del grid
 * v.1.47 01/04/2020 Modificamos la lista al recibirla, para quitar los nulls de los Foreign.
 * v.1.48 13/04/2020 Añadido el parametro ifid={gridConfig.ifid} al renderizar <GridPaginado
 * v.1.49 15/04/2020 Añadida propiedad usuario.
 *                   Paso del usuario a GridPaginado.
 * v.1.50 27/04/2020 paso de propiedad mostrarFilaActiva a GridPaginado
 *                   En onRefreshData, en el caso de análisis, cambiado gridConfig.columnas.size por gridConfig.columnas.length
 * v.1.51 06/05/2020 En guardarRow en el caso de nuevo, cambiamos datos[datos.length-1]=response por datos.push(response);
 * v.1.52 29/03/2020 En renderOnlyGrid <FormularioBotonera añadidas las props botonesAdicionales, onBotonAdicionalClick y onGridConfigurarClick
 *                   En el evento onClickBotonAdicional, pasar de parámetro el elemento o null según tenga mostrarSinElementos
 * //no: v.1.53 15/07/2020 En Load, para el caso de los análisis, añadimos los parámetros
 * v.1.53 24/07/2020 Añadido evento onDatosModificados.
 *                   Añadida pripiedad onDatosModificados en llamada a <GridPaginado
 * v.1.54 14/09/2020 En el evento Render: Añadido texto en tabs " - F2" en la pestaña no activa.
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  19/10/2020 Añadida propiedad onFiltroBusquedaChanged para pasar al Formulario el FiltroBusqueda y poder usarlo de nuevo tras volver de modificar elemento.
 *                   En constructor, inicializamos filtroBusqueda con la prop o con el objeto literal.
 *                   Añadido evento onFiltroBusquedaChanged para que el padre pueda guardar el filtrode búsqueda-
 * v.2.2 20/10/2020  Gestión de gridConfig.mostrarFilaActiva y paso correcto a GridPaginado
 * v.2.3 26/10/2020  Usamos la propiedad valoresIgnorar para no incluirlo en el filtro.
 * v.2.4 09/11/2020  Modificamos loadDatos, para no generar automaticamente el filtro de los campos con valor noFitrar == true.
 * v.2.5 12/11/2020  En método loadDatos : Limpiamos el campo noFiltrar de las condiciones del filtro.
 * v.2.6 13/11/2020  Desdoblamos loadDatos en loadDatosConFiltro y loadDatosServicio
 *
 *
 *
 * v.2.7 20/11/2020  Añadidas propiedades modoMostrarDatos, mostrarConmutadorModoMostrarDatos y onConmutarModoMostrarDatos.
 *                   Añadidos valores predefinidos MODO_MOSTRARDATOS_GRID y MODO_MOSTRARDATOS_TABLA
 *                   En renderTabs, añadida llamada a <TablaFlexPaginada
 *                   En renderTabs, añadidas propiedades  mostrarConmutadorModoMostrarDatos, modoMostrarDatos, onConmutarModoMostrarDatos,
 *                      a la llamada <FormularioBotonera...
 *                   Creado método conmutarModoMostrarDatos que se llama desde <FormularioBotonera
 *                   En onRefreshData, cuando se hace una nueva carga desde el servidor, se fuerza paginaSelected: 0.
 *                   Creamos la propiedad childTablaFlex que guarda el child que pasamos a <TablaFlexPaginada
 * v.2.8 22/11/2020  En el método guardarRow:
 *                      se añade delete elementoPreparado.filaSeleccionada;
 *                      a la urlPost le añadimos al final el código del elemento.
 * v.2.9 12/12/2020  Pasada la propieda estilo a <GridPaginado con el valor de gridConfig.estilo
 *                   Nueva propiedad onDobleClickCelda
 *                   Añadido método onDobleClickCelda que llama a la propiedad anterior.
 * v.2.3 09/04/2021  En LoadDatosConFiltro, se ha modifiado el tratamiento de los filtroBusqueda.condiciones.
 * v.2.4 19/04/2021  En Render, en la llamada a <FormularioBotonera... mostrarGridConfigurar={ gridConfig.mostrarGridConfigurar}
 *
 * V.2.5  06/07/2021 Añadida propiedad usarFiltros35
 *                   En loadDatosConFiltro añadido el código de usuario al Filtro
 *                   Añadido la propiedad gridAviso, para pasarlo al Grid.
 * v.2.10 29/07/2021 Pasamos a GridPaginado urlServicioRestful desde gridConfig.urlServicioRestful
 *                   En las llamadas a <GridPaginado le pasamos el parametro usarFiltros35
 * v.2.11 02/08/2021 Modificado el evento onSelectedRow para que sólo tenga de parámetro el elemento seleccionado.
 *                   En el método guardarRow, añadimos delete elementoPreparado.rowIdx
 * v.2.12 10/08/2021 En <GridPaginado> añadida la propiedad funcRefreshData, un enlace a la función refreshData para provocar un refresco completo.
 *
 * En loadDatosConfiltro, añadimos la condicion posFiltroCampoEncontrado  >= 0) en el caso else de if (!Boolean(filtroBusquedaActual.noFiltrar))
 *
 * v.2.13 04/05/2021 En renderTabs: modificamos la declaración de las variables tituloTabDatos y tituloBusqueda para que tengan iconos.
 * v.2.14 08/06/2021 En RenderOnlyGRid, tomamos valorBusqueda de Props
 *                   Se añade id como parámetro y se pasa a GridPaginado
 * v.2.15  21/06/2022 En renderTabs, Añadida condición  "&& !gridConfig.botonesAdicionales" a mostrarAcciones= false
 * v.2.16  15/07/2022 En loadDatosConFiltro, en Carga de Análisis, si existe usuario pasamos en los parámetros el código de usuario.
 *                    En método filtroToPostObject, en el caso default también añadimos al objeto.
 * v.2.17  26/07/2022 Modificaciones en el cálculo del filtro para no filtrar por los campos de gridConfig.busquedaCampos cuando no se muestra la busqueda (showBusqueda)
 *
 * v.2.18  01/09/2022 Cuando se carga el PostObject al hacer el LoadDatos de un Análisis, le añadimos los parámetros de gridConfig.parametrosAdicionalesFiltro.
 * v.2.19  26/09/2022 En OnSelectRow, añadimos un segundo parámtro con el numero de row seleccionada.
 * v.2.20 17/11/2022 Añadida propiedad childrenFormulariogrid.
 *                   Modificado en el renderOnlyGrids y renderTabs, para mostrar los componentes del parámetro childrenFormulariogrid.
 * v.2.21 24/11/2022 Modificado loadDatosServicio: en la carga de Análisis añadida la comprobación  if (gridConfig.parametrosAdicionalesFiltro) {
 * v.2.22 30/01/2022 Modificado en componentDidMount la llamada a la búsqueda inicial this.onRefreshData(offset, true);
 *                       Se ha sustituido por this.refFormularioGridBusqueda.current.buscar() para que la búsqueda inicial tome el fitrado por defecto de las opciones de búsqueda.
 * v.2.23 07/02/2022 Añadida propiedad onDespuesGuardarElemento
 *                   En guardarRow, cuando hay éxito, llamamos a la propiedad onDespuesGuardarElemento
 * v.2.24 24/04/2023 Añadida gestion de gridConfig.mostrarModificar y gridConfig.onModificar
 * v.2.25 25/04/2023 Añadida gestion de gridConfig.mostrarEliminar y gridConfig.onEliminar
 *                   En el evento onAccion, esperamos el parámetro "elemento" para transmitirlo en la llamada.
 * v.2.26 26/04/2023 Añadida propiedad gridConfig.tabInicial para controlar en qué tab aparece.
 *                   Modificado componentDidMount para tener en cuenta gridConfig.tabInicial.
 * v.2.27 08/05/2023 Añadida propiedad llamadoDesdeOtroFormulario
 *                   Modificado el constructor para calcular la tab selecionada en función de gridConfig.tabInicial y llamadoDesdeOtroFormulario
 *                   Modificado  componentDidMount para que use state.selectedTab y no props.gridConfig.tabInicial.
 * v.2.28 30/05/2023 En el metodo onSelectedRow, añadimos un tercer parámetro que es un callback, al que se llama al terminar.
 * v.2.29 13/07/2023 Añadida la propiedad desdeMovil: PropTypes.bool
 *                    Usada la propiedad desdeMovil en la llamada a <GridPaginado
 * v.2.30 28/07/2023 Añadida la propiedad onSelectedRowsChanged
 *                      Añadidas onSelectedRowsChanged y mostrarChecksSeleccion en la llamada a <GridPaginado
 * v.2.31 01/08/2023 Modificado inicializarDatosBusqueda, para inicializar correctamente los booleanos.
 * v.2.32 21/09/2023 Creado método onSelectedRowsChanged, que se dispara al modificar la multiselección.
 *                   Modificada la llamada a <GridPaginado para que utulice this.onSelectedRowsChanged.
 *                   Modificado método onBotonAdicionalClick, para mandar al boton.onClick( como parámetro o bien el elemento seleccionado o la lista de codigos seleccionados
 * v.2.33 24/01/2024 En el método inicializarDatosBusqueda. en el caso de que no exista DatosBúsqueda, añadida la carga desde campo.valorInicial
 *
 * v.2.34 20/06/2024 En render, en la condicion "if (gridConfig.busquedaCampos", añadimos la condición "&& gridConfig.busquedaCampos.length > 0".
 * v.2.35 26/06/2024 Añadida la propiedad childrenFormulariogridPre
 *
 * v.2.36 18/09/2024 Añadido mostrarEliminar y onEliminar en la llamada <GridPaginado de renderOnlyGrid.
 */

import React from 'react'

import PropTypes from 'prop-types';
import GridPaginado, {PAGINACIONTIPO_NORMAL} from '../UI/GridPaginado'
import ClienteRestful from "../network/ClienteRestful";
import {Icon, Tab, Tabs} from "@blueprintjs/core";
import FormularioGridBusqueda, {
    BUSQUEDACAMPOTIPO_CHECK,
    BUSQUEDACAMPOTIPO_FECHAPERIODO, 
    FILTRO_ENTREFECHAS,
    FILTRO_MAYOR,
    FILTRO35_ENTREFECHAS,
    FILTRO35_MAYOR
} from './FormularioGridBusqueda'
import FormularioBotonera, { BOTONERA_ACCION_EXCEL, BOTONERA_ACCION_PDF, BOTONERA_ACCION_REFRESCAR} from "./FormularioBotonera";
import KeyboardEventHandler from 'react-keyboard-event-handler';
import {exportarExcel, exportarExcelLocal, exportarPdf, exportarPdfLocal, exportarPdfLocalUI, exportarPdfLocalEmpresaSvg} from "../utils//ExportarUtils";
import {calcularDatosConPie, calcularDatosConPdfCampo, calcularColumnasSinPdfCampo, corregirDatosCamposNull} from "../utils/DatosUtils";
import {getFormattedISO8601FromTimestamp} from "../utils/DateUtils"
import {getFiltroFromCampo, getFiltroInicialFromCampoFECHAPERIODO, getFiltroFromCampo35, getFiltroInicialFromCampoFECHAPERIODO35} from "../utils/FiltroGridUtils";
import {getColumnas, getDatos} from "../utils/DataTableUtils";
import {log, logId} from "../utils/ConsoleUtils";
import {contieneElementoConNombreCampo} from "../utils/FilterUtils";
import {compararArrays, compararObjetos} from "../utils/ObjectUtils";
import {contiene, posPrimerElementoConValorPropiedad, primerElementoConValorPropiedad} from "../utils/ArrayUtils";
import {servicioRestfulCompleto, servidor, tipoPasarela} from "../../../dental/Configuracion";
import {validarEntidad} from "../utils/EntidadUtils"
import TablaFlexPaginada from "./TablaFlexPaginada";
import {ELEMENTO_MODOCARGA_BDD} from "./Formulario";

export const MODO_MOSTRARDATOS_GRID = 1;
export const MODO_MOSTRARDATOS_TABLA = 2;

class FormularioGrid extends React.Component {

    constructor(props) {
        super(props)

        //console.log("Constructor");
        //console.log("gridConfig.tabInicial: ", props.gridConfig.tabInicial);
        let tabInicial= props.gridConfig.tabInicial  ? props.gridConfig.tabInicial : "datos";
        if (props.llamadoDesdeOtroFormulario && Boolean(props.llamadoDesdeOtroFormulario))
            tabInicial= "datos";
        //console.log("tabInicial: ", tabInicial);

        this.state = {
            selectedTab:tabInicial,
            datos: [],
            gridConfig: props.gridConfig,
            filtroBusqueda: props.filtroBusqueda ? props.filtroBusqueda : { condiciones: [], orden: [] },
            datosBusqueda: this.inicializarDatosBusqueda(props.gridConfig, props.datosBusqueda),
            paginaActual: props.paginaActual ? props.paginaActual : 0,
            marcaTiempo: props.marcaTiempo,
            cargandoDatos: false,
            elementoSeleccionado: props.elementoSeleccionado,
            filtroFijoCargado: null, // props.gridConfig ? props.gridConfig.filtroFijo : null,
            listasElementosCombos: {},
            cargandoListasElementosCombos: false,
            modoMostrarDatos: props.modoMostrarDatos ? props.modoMostrarDatos : MODO_MOSTRARDATOS_GRID,
            elementosSeleccionadosClaves: [],
        }
        this.refFormularioGridBusqueda = React.createRef();
        this.refGridPaginado = React.createRef();

        //console.log(" <<<<<<< FORMULARIO GRID CONSTRUCTOR >>>>>");
        //console.log("Constructor:");
        //console.log("filtroBusqueda:");
        //console.log(this.state.filtroBusqueda);
    }

    componentDidMount() {
        const {paginaActual, elementoSeleccionado, modoMostrarDatos, selectedTab} = this.state;
        const {gridConfig, infoDatosInicial} = this.props;

        //console.log("FORMULARIO GRID - ComponentDidMount");
        //console.log("selectedTab: ", selectedTab);

        this.setState({gridConfig: gridConfig});
        if (selectedTab != "busqueda"){
            let esperarFiltroFijo= gridConfig.esperarFiltroFijo;
            if( !esperarFiltroFijo ||
                (typeof esperarFiltroFijo === 'boolean' && esperarFiltroFijo === false) ) {

                    if (infoDatosInicial){
                        let offset= paginaActual * gridConfig.elementosPorPagina;
                        let numElementos=  gridConfig.elementosPorPagina;
                        if (modoMostrarDatos == MODO_MOSTRARDATOS_TABLA) {
                            offset = paginaActual * gridConfig.elementosPorPaginaTabla;
                            numElementos = gridConfig.elementosPorPaginaTabla;
                        }

                        let datos= gridConfig.loadTodasPaginas ? this.filtrarDatos(infoDatosInicial.datos, offset, numElementos)
                                        : infoDatosInicial.datos;

                        //Vemos si el elementos seleccionado está en datos. Si no lo cambiamos por el primer elemento
                        let elementoSeleccionadoReal= elementoSeleccionado;
                        if (datos.length > 0) {
                            if (!contieneElementoConNombreCampo(datos, "codigo", elementoSeleccionado.codigo))
                                elementoSeleccionadoReal = null;
                        }
                        else{
                            elementoSeleccionadoReal= null;
                        }

                        this.setState({
                            datosOriginales: infoDatosInicial.datos,
                            //Los datos de la pagina actual, si se cargan todos hay que filtrarlos, si no ya vienen puestos en infodatos.
                            datos: datos,
                            numTotalDatos: infoDatosInicial.numTotalDatos,
                            numPaginas: infoDatosInicial.numPaginas,
                            cargandoDatos: false,
                            filtroFijo: gridConfig.filtroFijo,
                            elementoSeleccionado: elementoSeleccionadoReal});

                    }
                    else {
                        let offset = Math.ceil(paginaActual * gridConfig.elementosPorPagina);
                        if (modoMostrarDatos == MODO_MOSTRARDATOS_TABLA)
                            offset = Math.ceil(paginaActual * gridConfig.elementosPorPaginaTabla);

                        //console.log("OnRefreshData desde ComponentDidMount")
                        //Nuevo:
                        //Llamamos a FormularioGRdiBusqueda para obtener sus datos de filtrado por defecto:
                        //console.log("this.refFormularioGridBusqueda: ", this.refFormularioGridBusqueda);
                        //console.log("this.refFormularioGridBusqueda.current: ", this.refFormularioGridBusqueda.current);
                        if (this.refFormularioGridBusqueda.current)
                            this.refFormularioGridBusqueda.current.buscar();
                        else
                            this.onRefreshData(offset, true);
                        //antes: this.onRefreshData(offset, true);
                    }

                }
            }

        //Creamos las listas de los combos si hiciera falta:
        //this.cargarListasElementosCombos(gridConfig.columnas);
    }

    componentDidUpdate(prevProps, prevState) {
        //Comprobamos si han cambiado cosas que hagan necesario un refresco:
        //console.log("formulariogrid - DID UPDATE");
        let refrescarDatos= false;

        if (prevState.marcaTiempo !== this.state.marcaTiempo) {
            refrescarDatos= true;
        }

        if (refrescarDatos) {
            //console.log("Refrescar Datos ***");
            this.onRefreshData(0, true);
        }

        /*
        if (nextProps.gridConfig  && nextProps.gridConfig.filtroFijo &&
            !compararArrays(nextProps.gridConfig.filtroFijo, prevState.filtroFijoCargado)) {
            refrescarDatos= true;
        }

        if (!compararObjetos(nextProps.gridConfig, prevState.gridConfig)){
            newState.gridConfig = nextProps.gridConfig;
            refrescarDatos= true;
        }

        if (nextProps.marcaTiempo !== prevState.marcaTiempo) {
            newState.marcaTiempo = nextProps.marcaTiempo;
            refrescarDatos= true;
        }
        */
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        //console.log("GET DERIVED");
        const newState = {};

        if (!compararObjetos(nextProps.gridConfig, prevState.gridConfig)){
            newState.gridConfig = nextProps.gridConfig;
        }

        if (nextProps.marcaTiempo !== prevState.marcaTiempo) {
            newState.marcaTiempo = nextProps.marcaTiempo;
        }

        if (nextProps.gridAviso !== prevState.gridAviso) {
            newState.gridAviso = nextProps.gridAviso;
        }

        /*
        if (nextProps.datosBusqueda !== prevState.datosBusqueda) {
            newState.datosBusqueda = nextProps.datosBusqueda;
        }
        */

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    //-------------------------------------------------------------

    inicializarDatosBusqueda= (gridConfig, datosBusqueda) => {
        /*
        console.log("****************");
        console.log("**************** inicializarDatosBusqueda");
        console.log("datosBusqueda: ", datosBusqueda);
        console.log("gridConfig.busquedaCampos: ", gridConfig.busquedaCampos);
        */

        let newDatosBusqueda= {};
        if (gridConfig.busquedaCampos) {
            gridConfig.busquedaCampos.forEach((campo) => {
                //console.log("campo: ", campo);
                if (datosBusqueda){
                    //HAcemos un tratamiento distinto cuando es booleano para que no se confunda el valor false con indefinido
                    if (typeof datosBusqueda[campo.campo]=== 'boolean'){
                        newDatosBusqueda[campo.campo] = datosBusqueda[campo.campo];
                    }
                    else{
                        if (datosBusqueda[campo.campo])
                            newDatosBusqueda[campo.campo] = datosBusqueda[campo.campo];
                    }
                }
                else {
                    if (campo.valorInicial) {
                        //console.log("Asignando valorImicial: ", campo.valorInicial);
                        newDatosBusqueda[campo.campo] = campo.valorInicial;
                    }
                    if (campo.valor) {
                        //console.log("Asignando valor: ", campo.valor);
                        newDatosBusqueda[campo.campo] = campo.valor;
                    }
                }
            });
        }
        //console.log("newDatosBusqueda: ", newDatosBusqueda);
        return newDatosBusqueda;
    }

    onChangeTab = (tabId) => {
        this.setState({selectedTab: tabId});
    }

    //onEnd es necesario para que retorne el evento cuando haya terminado la asignación, por ejemplo al cargarla.
    onSelectedRow= (elemento, row, callback) => {
        //console.log("FORMULARIOGRID - ONSELECTEDRROW");
        //console.log("onEnd: ", onEnd);
        //console.log("elemento: ", elemento);
        const {onElementoSeleccionado, gridConfig} = this.props;
        this.setState({elementoSeleccionado: elemento}, () => {
            onElementoSeleccionado && onElementoSeleccionado(elemento, callback);
        })
    }

    onSelectedRowsChanged= (newElementosSeleccionadosClaves) => {
        const {onSelectedRowsChanged} = this.props;
        console.log("---- FORMULARIOGRID ONSELECTEDROWSCHANGED");
        console.log("newElementosSeleccionadosClaves: ", newElementosSeleccionadosClaves);
        this.setState({elementosSeleccionadosClaves: newElementosSeleccionadosClaves}, () =>{
            onSelectedRowsChanged && onSelectedRowsChanged(newElementosSeleccionadosClaves);
        });

    }

    onPageChanged= (offset, paginaSelected) => {
        const {onPageChanged} = this.props;
        this.setState({paginaActual: paginaSelected});
        this.onRefreshData(offset, false);
        onPageChanged && onPageChanged(paginaSelected);
    }

    onRefreshData= (offset, filtrosModificados) => {
        const {gridConfig, datos, datosOriginales, modoMostrarDatos} =  this.state;
        const {onElementoSeleccionado} = this.props;

        //console.log("onRefresh Data");
        //console.log("filtrosModificados:", filtrosModificados);

        //Búsqueda sobre entidad
        let todasPaginas= gridConfig.loadTodasPaginas ? true : false; //#25/10/2019
        if (gridConfig.url && gridConfig.className) {
            //Solo llamamos a loadDatos si hay que recargar desde el servido:
            if (!todasPaginas || filtrosModificados|| datos.length == 0) {
                this.setState({cargandoDatos: true, paginaSelected: 0}, this.loadDatos(offset, todasPaginas))
            }
            else {
                let numDatos= gridConfig.elementosPorPagina;
                if (modoMostrarDatos == MODO_MOSTRARDATOS_GRID)
                    numDatos= gridConfig.elementosPorPaginaTabla;
                let newDatos = this.filtrarDatos(datosOriginales, offset, numDatos);
                let newElementoSeleccionado = newDatos.length > 0 ? newDatos[0] : null;
                this.setState({datos: newDatos, elementoSeleccionado: newElementoSeleccionado}, () => {
                    onElementoSeleccionado && onElementoSeleccionado(newElementoSeleccionado);
                });
            }
        }
        //Búsqueda sobre análisis
        else{
            if (gridConfig.columnas.length > 0) {
                //Si han cambiado los filtros de busqueda se llama al servlet
                if (!todasPaginas || filtrosModificados|| datos.length == 0) {
                    this.setState({cargandoDatos: true}, this.loadDatos(offset, todasPaginas));
                }
                //Si no han cambiado las opciones de búsqueda filtramos entre los datos que ya tenemos.
                else {
                    let newDatos = this.filtrarDatos(datosOriginales, offset, gridConfig.elementosPorPagina);
                    this.setState({datos: newDatos});
                }
            }
            else{
                //Datos de análisis en formato DataTable
                this.setState({cargandoDatos: true}, this.loadDatos(offset, true));
            }
        }
    }

    onCeldaClick= (elemento) => {
        const {onElementoSeleccionado} = this.props;
        this.setState({elementoSeleccionado: elemento}, () => {
            onElementoSeleccionado && onElementoSeleccionado(elemento);
        })
    }

    onCeldaDobleClick= (elemento) => {
        const {onElementoSeleccionado, onDobleClickCelda} = this.props;
        this.setState({elementoSeleccionado: elemento}, () => {
            onDobleClickCelda && onDobleClickCelda(elemento);
        })

    }

    //------------------------------------------------------------------------------------------------------------------
    // MODO MOSTRAR DATOS
    //------------------------------------------------------------------------------------------------------------------

    conmutarModoMostrarDatos= (newModoMostrarDatos) => {

        this.setState({modoMostrarDatos: newModoMostrarDatos}, () => this.onRefreshData(0,true));
    }

    //------------------------------------------------------------------------------------------------------------------
    // FILTRO Y CARGA DE DATOS
    //------------------------------------------------------------------------------------------------------------------

    filtroOffsetTransformarCampos = (filtroOffset) =>{
        let newFiltroOffset= {...filtroOffset};
        newFiltroOffset.condiciones= [];
        if (filtroOffset && filtroOffset.condiciones) {
            filtroOffset.condiciones.forEach((condicion) => {
                let newCondicion = {...condicion};
                //Se usa FILTRO_ENTREFECHAS porque viene de FormularioGridBusqueda
                switch (condicion.tipo) {
                    case FILTRO_ENTREFECHAS:
                    case FILTRO35_ENTREFECHAS:
                        newCondicion.valor = getFormattedISO8601FromTimestamp(condicion.valor);
                        newCondicion.valor2 = getFormattedISO8601FromTimestamp(condicion.valor2);
                        break;
                    default:
                        break;
                }
                newFiltroOffset.condiciones.push(newCondicion);
            });
        }
        /*
        console.log("filtroOffsetTransformarCampos -- ");
        console.log("newFiltroOffset");
        console.log(newFiltroOffset);
        */
        return newFiltroOffset;
    }

    filtroToPostObject = (filtro) =>{
        const{gridConfig} = this.state;
        let newPostObject= {...gridConfig.postObject};

        /*
        console.log("++filtroToPostObject");
        console.log("filtro: ", filtro);
        console.log("newPostObject: ", newPostObject);
        console.log("filtro.condiciones: ", filtro.condiciones);
        */

        newPostObject.posInicial = filtro.posInicial;
        newPostObject.numElementos= filtro.numElementos;

        filtro.condiciones.forEach( (condicion) => {
            //console.log("condicion: ", condicion);
            //Se usa FILTRO_ENTREFECHAS porque viene de FormularioGridBusqueda
            switch (condicion.tipo){
                case FILTRO_ENTREFECHAS:
                case FILTRO35_ENTREFECHAS:
                    newPostObject.desde= getFormattedISO8601FromTimestamp(condicion.valor);
                    newPostObject.hasta= getFormattedISO8601FromTimestamp(condicion.valor2);
                    break;
                default:
                    newPostObject[condicion.nombreCampo]= condicion.valor;
                    break;
            }
        });
        //console.log("newPostObject: ", newPostObject);
        return newPostObject;
    }

    loadDatos= (offset, todasPaginas, callbackTodosDatosCargados) => {
        const {gridConfig} = this.props;
        //console.log("XXXXXXXXXXXXXXXXXXXXXXXx loadDatos");
        //console.log("gridConfig.parametrosServicio: ", gridConfig.parametrosServicio);
        if (!gridConfig.parametrosServicio)
            this.loadDatosConFiltro(offset, todasPaginas, callbackTodosDatosCargados);
        else
            this.loadDatosServicio(callbackTodosDatosCargados);
    }

    loadDatosServicio= (callbackTodosDatosCargados) => {
        const {gridConfig, modoMostrarDatos} = this.state;
        const {onModificarDatosCargados, onDatosCargados} = this.props;

        console.log("LOAD DATOS CON SERVICIO");

        let parametrosServicio= gridConfig.parametrosServicio;
        let urlLista= gridConfig.url;
        //console.log("URL: ", urlLista);
        //console.log("parametrosServicio: ", parametrosServicio);

        const clienteRestful = new ClienteRestful().setUrl(urlLista);

        clienteRestful.doPost(parametrosServicio, response => {
            //console.log("*****")
            console.log(response);
            let datos= response;
            let numTotalDatos= datos.length;

            let numPaginas= 0;
            if (gridConfig.elementosPorPagina > 0)
                numPaginas = numTotalDatos / gridConfig.elementosPorPagina;

            let datosLoaded= datos
            if (onModificarDatosCargados){
                datosLoaded= onModificarDatosCargados(datosLoaded);
            }

            //Para controlar si es la primera llamada
            let datosPagina= datosLoaded;
            console.log("datosPagina: ", datosPagina);


            if (gridConfig.loadTodasPaginas) {
                let numDatos= gridConfig.elementosPorPagina;
                if (modoMostrarDatos == MODO_MOSTRARDATOS_TABLA)
                    numDatos= gridConfig.elementosPorPaginaTabla;
                datosPagina = this.filtrarDatos(datosLoaded, 0, numDatos);
            }
            let newElementoSeleccionado = datosPagina.length > 0 ? datosPagina[0] : null;
            this.setState({datos: datosPagina, datosOriginales: datosLoaded, numTotalDatos: numTotalDatos,
                elementoSeleccionado: newElementoSeleccionado,
                numPaginas: numPaginas, cargandoDatos: false, filtroFijoCargado: gridConfig.filtroFijo});
            onDatosCargados && onDatosCargados({datos:datosLoaded, numTotalDatos: numTotalDatos, numPaginas: numPaginas});
            callbackTodosDatosCargados && callbackTodosDatosCargados(datos);
        });

    }

    loadDatosConFiltro= (offset, todasPaginas, callbackTodosDatosCargados) => {
        const {gridConfig, filtroBusqueda, datos, datosBusqueda, modoMostrarDatos} =  this.state;
        const {onDatosCargados, onModificarDatosCargados, onAntesCargarDatos, usarFiltros35, usuario, showBusqueda} = this.props;

        //console.log("LOAD DATOS CON FILTRO");
        //console.log("usuario: ", usuario);
        //console.log("FORMULARIOGRID - LOADDATOS");
        //console.log("Filtro Búsqueda", filtroBusqueda);
        //console.log("datosBusqueda", datosBusqueda);
        //console.log("showBusqueda: ", showBusqueda);

        let filtro= {condiciones: [], orden: []};
        if (gridConfig.busquedaCampos) {
            //console.log("gridConfig.busquedaCampos: ", gridConfig.busquedaCampos);

            gridConfig.busquedaCampos.forEach ( (campo) => {
                 //Si no hay que usra el campo para filtrar directamente (se usa para filtro construido externamente)
                //Si no se muestran las opciones de búsqueda, no se filtra.
                let noFiltrar=  (campo.noFiltrar != undefined  && Boolean(campo.noFiltrar)) || !Boolean(showBusqueda);

                //console.log("campo.campo: ", campo.campo);
                //console.log("noFiltrar: ", noFiltrar);

                if (!noFiltrar) {
                    if (campo.valor) {
                        //console.log("* campo: ", campo.campo, " -> ", campo.valor);
                        let valoresIgnorar = campo.valoresIgnorar ? campo.valoresIgnorar : [];
                        if (!contiene(valoresIgnorar, campo.valor)) {
                            let filtroCampo = usarFiltros35 ? getFiltroFromCampo35(campo, campo.valor, campo.valor2): getFiltroFromCampo(campo, campo.valor, campo.valor2);
                            if (filtroCampo)
                                filtro.condiciones.push(filtroCampo);
                        }
                    }

                    //Copiamos los datos iniciales si fuera necesario:
                    if (campo.tipoValor) {
                        let filtroCampo = usarFiltros35 ? getFiltroInicialFromCampoFECHAPERIODO35(campo) : getFiltroInicialFromCampoFECHAPERIODO(campo);
                        if (filtroCampo)
                            filtro.condiciones.push(filtroCampo);
                    }
                }
            });
        }
        //console.log("filtro.condiciones: ", filtro.condiciones.length);

        //console.log("Filtro Busqueda: ", filtroBusqueda.condiciones);
        //console.log("* filtroBusqueda");
        filtroBusqueda && filtroBusqueda.condiciones.forEach( (filtroBusquedaActual) => {
            //Si no existe ese campo se añade y si existe se sustituye:
            //console.log("filtroBusquedaActual: ", filtroBusquedaActual);
            let campoEncontrado = false;
            let filtroCampoEncontrado= null;
            let posFiltroCampoEncontrado= -1;
            filtro.condiciones.forEach((filtroCampoActual, index) => {
                if (filtroCampoActual.nombreCampo === filtroBusquedaActual.nombreCampo) {
                    filtroCampoEncontrado= filtroCampoActual
                    campoEncontrado = true;
                    posFiltroCampoEncontrado= index;
                }
            });
            //console.log("filtroCampoActual: ", filtroBusquedaActual.nombreCampo, " -> ", filtroBusquedaActual.valor);
            //console.log("campoEncontrado; ", campoEncontrado);
            if (!Boolean(filtroBusquedaActual.noFiltrar)) {
                if (!campoEncontrado) {
                    //console.log("Added: ")
                    //Añadimos directamente
                    filtro.condiciones.push(filtroBusquedaActual);
                }
                else{
                    //Sustituimos el valor
                    //console.log("Sustituir: ");
                    filtroCampoEncontrado.valor = filtroBusquedaActual.valor;
                    filtroCampoEncontrado.valor2 = filtroBusquedaActual.valor2;
                }
            }
            else{
                //Si es el valor de ignorar, debemos mirar si previamente se ha añadido dicho campo al filtro por un valor por defecto.
                //console.log("Caso X");
                //console.log("posFiltroCampoEncontrado: ", posFiltroCampoEncontrado);
                //console.log("filtro.condiciones: ", filtro.condiciones);
                if (posFiltroCampoEncontrado  >= 0) //añadido en 03/2022
                    filtro.condiciones.splice(posFiltroCampoEncontrado, 1);
            }
        });
        //console.log("FILTRO C ", filtro.condiciones);

        //Limpiamos el campo noFiltrar de las condiciones del filtro, para evitar un error ya que ese campo no existe en la clase JAVA:
        filtro.condiciones.forEach( (condicion) => {
            delete (condicion.noFiltrar);
        });


        //Añadimos condicion de cero inmutable
        if (gridConfig.noMostrarCero){
            filtro.condiciones.push(
                {nombreCampo: "codigo", tipo: usarFiltros35 ? FILTRO35_MAYOR :  FILTRO_MAYOR,  valor: 0},
            );
        }

        //Añadimos el filtroFijo
        if (gridConfig.filtroFijo){
            gridConfig.filtroFijo.forEach( (filtroFijoActual) => {
               filtro.condiciones.push(filtroFijoActual);
            });
        }

        //console.log("filtro.condiciones 2: ", filtro.condiciones.length);

        //Quitamos las condiciones tipo Check con valor = false
        //Pero sólo si se usan ls condiciones
        if (showBusqueda) { //nuevo
            //console.log("condicionesSinChecksCero");
            let condicionesSinChecksCero = [];
            filtro.condiciones.forEach((condicion) => {
                if (condicion.tipoCampo !== BUSQUEDACAMPOTIPO_CHECK ||
                    (condicion.tipoCampo === BUSQUEDACAMPOTIPO_CHECK && condicion.valor === 1)) {
                    delete condicion.tipoCampo;
                    condicionesSinChecksCero.push(condicion);
                }
            })
            filtro.condiciones = condicionesSinChecksCero;
        }

        //Añadimos el ordeninicial
        if(gridConfig.ordenInicial){
            filtro.orden.length= 0;
            filtro.orden.push(...gridConfig.ordenInicial);
        }

        //console.log("filtro.condiciones 3: ", filtro.condiciones.length);

        let filtroOffset= {...filtro};
        //console.log("filtroOffset -2: ", filtroOffset.condiciones.length);
        if (!todasPaginas) {
            filtroOffset.posInicial = offset;
            if (modoMostrarDatos == MODO_MOSTRARDATOS_TABLA)
                filtroOffset.numElementos = gridConfig.elementosPorPaginaTabla;
            else
                filtroOffset.numElementos = gridConfig.elementosPorPagina;
        }
        else{
            filtroOffset.posInicial = 0;
            filtroOffset.numElementos = 0;
        }

        //console.log("onAntesCargarDatos: ", onAntesCargarDatos);
        //console.log("datosBusqueda: ", datosBusqueda);
        if (onAntesCargarDatos){
            filtroOffset= onAntesCargarDatos(filtroOffset, datosBusqueda);
        }


        //Si hay usuario añadimos el usuario como parámetro
        //if (!showBusqueda)
            filtroOffset.usuarioCodigo= usuario ? usuario.codigo : 0;

        //console.log("filtroOffset -1: ", filtroOffset.condiciones.length);

        //Carga de clase Restful
        if (gridConfig.url && gridConfig.className) {
            let urlLista= gridConfig.url + "list/" + gridConfig.className;
            let filtroOffsetTransformado= this.filtroOffsetTransformarCampos(filtroOffset);
            const clienteRestful = new ClienteRestful().setUrl(urlLista);

            console.log("FORMULARIOGRID - LOAD");
            console.log("url: " + urlLista);
            console.log("filtro:", filtroOffsetTransformado);

            clienteRestful.doPost(filtroOffsetTransformado, response => {
                let datosLoaded= null
                let numTotalDatos= 0;

                console.log(response);

                if (tipoPasarela === "JPA"){
                    datosLoaded= this.addnivel(response);
                    numTotalDatos= clienteRestful.getNumTotalElements();
                    //console.log(numTotalDatos);
                }
                else{
                    datosLoaded = this.addnivel(response.lo);
                    numTotalDatos = response.totalElementos;
                }

                let numPaginas= 0;
                let elementosPorPagina= gridConfig.elementosPorPagina;
                if (modoMostrarDatos == MODO_MOSTRARDATOS_TABLA)
                    elementosPorPagina= gridConfig.elementosPorPaginaTabla;
                if (elementosPorPagina > 0)
                    numPaginas = numTotalDatos / elementosPorPagina;

                if (onModificarDatosCargados){
                    datosLoaded= onModificarDatosCargados(datosLoaded);
                }

                //Para controlar si es la primera llamada
                let datosPagina= datosLoaded;
                if (gridConfig.loadTodasPaginas) {
                    let numElementos=  gridConfig.elementosPorPagina;
                    if (modoMostrarDatos == MODO_MOSTRARDATOS_TABLA)
                        numElementos = gridConfig.elementosPorPaginaTabla;
                    datosPagina = this.filtrarDatos(datosLoaded, offset, numElementos);
                }
                let newElementoSeleccionado = datosPagina.length > 0 ? datosPagina[0] : null;

                console.log("datosPagina: ", datosPagina);

                this.setState({datos: datosPagina, datosOriginales: datosLoaded, numTotalDatos: numTotalDatos,
                    elementoSeleccionado: newElementoSeleccionado,
                    numPaginas: numPaginas, cargandoDatos: false, filtroFijoCargado: gridConfig.filtroFijo});
                onDatosCargados && onDatosCargados({datos:datosLoaded, numTotalDatos: numTotalDatos, numPaginas: numPaginas});
                callbackTodosDatosCargados && callbackTodosDatosCargados(datos);
            });
        }
        //Carga de analisis
        else{
            console.log("CARGA DE ANALISIS");
            //console.log("filtroOffset: ", filtroOffset);
            //console.log("url: ", gridConfig.url);


            const clienteRestful = new ClienteRestful().setUrl(gridConfig.url);
            //modificamos el postObject con los filtros de busqueda
            let postObject = this.filtroToPostObject(filtroOffset);
            //console.log("filtroToPostObject: ", postObject);
            postObject.usuarioCodigo = usuario ? usuario.codigo : 0;

            //console.log("gridConfig.parametrosAdicionalesFiltro: ", gridConfig.parametrosAdicionalesFiltro);
            if (gridConfig.parametrosAdicionalesFiltro) {
                Object.entries(gridConfig.parametrosAdicionalesFiltro).forEach(
                    ([key, value]) => {
                        postObject[key] = value;
                    }
                );
            }


            //console.log("FORMULARIO GRID");
            //console.log("url:" , gridConfig.url);
            console.log("postObject:", postObject);


            //Si debemos añadir parametros a la llamada al servicio del análisis
            /*
            if (gridConfig.parametrosAnalisis){
                postObject.parametrosAnalisis= gridConfig.parametrosAnalisis;
            }
            console.log(postObject);
            */

            clienteRestful.doPost(postObject, response => {
                //console.log("response: ", response);
                if (gridConfig.columnas.length > 0) {
                    //Análisis normal
                    console.log("CARGA DE ANALISIS NORMAL");
                    console.log(response);
                    let datos = this.addnivel(response);
                    let numTotalDatos = datos.length;

                    let numPaginas= 0;
                    if (gridConfig.elementosPorPagina > 0)
                        numPaginas = numTotalDatos / gridConfig.elementosPorPagina;

                    if (!todasPaginas) {
                        let datosPaginados = this.filtrarDatos(datos, offset, gridConfig.elementosPorPagina);
                        this.setState({
                            datos: datosPaginados,
                            datosOriginales: datos,
                            numTotalDatos: numTotalDatos,
                            numPaginas: numPaginas,
                            cargandoDatos: false
                        });
                    } else {
                        let datosPaginados = datos;
                        if (gridConfig.elementosPorPagina > 0 )
                            datosPaginados= this.filtrarDatos(datos, offset, gridConfig.elementosPorPagina);
                        this.setState({
                            datos: datosPaginados,
                            datosOriginales: datos,
                            numTotalDatos: numTotalDatos, //<---Nuevo
                            numPaginas: numPaginas,        //<---Nuevo
                            cargandoDatos: false,
                        }, () => {
                            onDatosCargados && onDatosCargados({datos:datos, numTotalDatos: numTotalDatos, numPaginas: numPaginas});
                            callbackTodosDatosCargados && callbackTodosDatosCargados(datos);
                        });
                    }
                }
                else{
                    //Análisis DataTable
                    //console.log("CARGA DE ANALISIS DATATABLE CON UI");

                    let datosDataTable = response;
                    //Obtenemos los datos y las columnas
                    let columnas= getColumnas(datosDataTable);
                    let datos= getDatos(datosDataTable);
                    let numTotalDatos = datos.length;
                    let numPaginas = numTotalDatos / gridConfig.elementosPorPagina;
                    let newGridConfig= {...gridConfig, columnas: columnas};

                    if (!todasPaginas && gridConfig.paginacionTipo === PAGINACIONTIPO_NORMAL) {
                        //console.log("A");
                        let datosPaginados = this.filtrarDatos(datos, offset, gridConfig.elementosPorPagina);
                        this.setState({
                            gridConfig: newGridConfig,
                            datos: datosPaginados,
                            datosOriginales: datos,
                            numTotalDatos: numTotalDatos,
                            numPaginas: numPaginas,
                            cargandoDatos: false
                        });
                    }else{
                        if (!todasPaginas){
                            //console.log("B");
                            this.setState({
                                gridConfig: newGridConfig,
                                datos: datos,
                                numTotalDatos: numTotalDatos,
                                cargandoDatos: false
                            });
                        }
                        else {
                            //console.log("C");
                            //console.log(datosDataTable);
                            this.setState({datos: datos, cargandoDatos: false, gridConfig: newGridConfig}, () => {
                                onDatosCargados && onDatosCargados(datosDataTable);
                                callbackTodosDatosCargados && callbackTodosDatosCargados(datos)
                            });
                        }
                    }


                }
            });

        }

    }

    filtrarDatos= (datosOriginales, offset, numElementos) => {
        if (numElementos > 0) //##Nuevo
            return datosOriginales.slice(offset, offset + numElementos);
        else
            return datosOriginales;
    }

    addnivel= (lo) => {
        let newLo= [];
        lo && lo.forEach ((o, index) => {
            let nivel= 0;
            if ( index % 3 === 0)
                nivel= 1;
            let newO= {...o};
            newO.nivel= nivel;
            newLo.push(newO);
        })
        return newLo;
    }

    onChangeFiltro= (datosBusqueda) => {
        const {onDatosBusquedaChanged} = this.props;

        console.log("FORMULARIOGRID - OnChangeFiltro");
        console.log(datosBusqueda);

        let newDatosBusqueda= {...datosBusqueda};
        this.setState({datosBusqueda: newDatosBusqueda});
        onDatosBusquedaChanged && onDatosBusquedaChanged(newDatosBusqueda);
    }

    onBuscar= (filtroBusquedaNew) => {

        console.log("formulariogrid - ONBUSCAR");
        console.log("filtroBusquedaNew", filtroBusquedaNew);

        const {onFiltroBusquedaChanged} = this.props;

        this.setState({filtroBusqueda: filtroBusquedaNew, selectedTab: 'datos'}, () => {
            this.onRefreshData(0,true);
            onFiltroBusquedaChanged && onFiltroBusquedaChanged(filtroBusquedaNew);
        });
    }

    onFBuscar= () => {
        const {selectedTab} = this.state;
        if (selectedTab === "busqueda"){
            this.refFormularioGridBusqueda.current.buscar();
        }
        else{
            if (selectedTab === "datos"){
                this.setState({selectedTab:"busqueda"});
            }
        }
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        //console.log("FormularioGrid - onAccion");
        //console.log("acccion: ", accion);
        //console.log("elemento: ", elemento);

        const {onAccion} = this.props;
        switch (accion){
            case BOTONERA_ACCION_PDF:
                //this.exportarPdf();
                this.exportarPdfLocal();
                break;
            case BOTONERA_ACCION_EXCEL:
                this.exportarExcelLocal();
                break;
            case BOTONERA_ACCION_REFRESCAR:
                this.onRefreshData(0, true);
                break;
            default:
                onAccion && onAccion(accion, elemento);
                break;
        }
    }

    //Si es un botón adicional que usa un elemento, pasamos el elemento seleccionado.
    //Si es un botón adicional que no usa elementos, pasamos el padre
    onBotonAdicionalClick= (boton) => {
        const {elementoSeleccionado, elementosSeleccionadosClaves} = this.state;
        /*
        console.log("XXXX onBotonAdicionalClick: ");
        console.log("elementoSeleccionado ", elementoSeleccionado);
        console.log("elementosSeleccionadosClaves: ", elementosSeleccionadosClaves);
        console.log("elementosSeleccionadosClaves.size: ", elementosSeleccionadosClaves.size);
        */
        if (boton.mostrarSinElementos)
            boton.onClick();
        else {
            if (elementosSeleccionadosClaves.size > 0) //Usamos .size porque se trata de un SET y no un Array
                boton.onClick(elementosSeleccionadosClaves);
            else
                boton.onClick(elementoSeleccionado);
        }
    }

    onGridConfigurarClick = () => {
        //Llamamos a la función del formulario Grid para mostrar
        this.refGridPaginado.current.configurarGrid();
    }

    exportarExcel= () => {
        const {gridConfig} = this.state;
        this.loadDatos(0, true, (datos) => {
            exportarExcel(calcularDatosConPie(gridConfig.columnas, datos), gridConfig.columnas);

        });
    }

    exportarExcelLocal= () => {
        const {gridConfig, datos} = this.state;
        //console.log("ExportarExcel");
        if (gridConfig.url && gridConfig.className) {
            exportarExcelLocal(calcularDatosConPie(gridConfig.columnas, datos), gridConfig.columnas);
            /*
            this.loadDatos(0, true, (datos) => {
                exportarExcelLocal(calcularDatosConPie(gridConfig.columnas, datos), gridConfig.columnas);
            });
             */
        }
    }

    exportarPdf= () => {
        const {gridConfig} = this.state;
        const {titulo} = this.props;

        this.loadDatos(0,  true, (datos) => {
            exportarPdf(titulo, gridConfig.variablesPDF, calcularDatosConPie(gridConfig.columnas, datos), gridConfig.columnas);
        });

    }

    exportarPdfLocal= () => {
        const {gridConfig} = this.state;
        const {titulo, empresa, nombreSvg} = this.props;

        //console.log ("ExportarPDFLocal");
        //console.log(gridConfig);

        //Si es un grid normal hay que pedir todos los datos:
        if (gridConfig.url && gridConfig.className) {
            this.loadDatos(0, true, (datos) => {
                exportarPdfLocalEmpresaSvg(gridConfig.pdfConfig, titulo, calcularDatosConPie(gridConfig.columnas, datos), gridConfig.columnas, empresa, null);
            });
        }
        else{
            const {datos} = this.state;
            exportarPdfLocalEmpresaSvg(gridConfig.pdfConfig, titulo,
                calcularDatosConPdfCampo(gridConfig.columnas, calcularDatosConPie(gridConfig.columnas, datos)),
                calcularColumnasSinPdfCampo(gridConfig.columnas),
                empresa, nombreSvg,
                gridConfig.variablesPDF);
        }

    }

    //------------------------------------------------------------------------------------------------------------------
    // GUARDADO DE ROWS
    //------------------------------------------------------------------------------------------------------------------

    onRowModificada = (objetoOld, objetoNew, rowIndex, callback) => {
        const {elementoConfig, onGuardarModoCargaBDD} = this.props;


        console.log("* onROWMODIFICADA");
        console.log("objetoOld: ", objetoOld);
        console.log("objetoNew: ", objetoNew);
        console.log("rowIndex: ", rowIndex);
        console.log("onGuardarModoCargaBDD: ", onGuardarModoCargaBDD);

        //Si se guarda de forma personalizada no hace falta validar.
        if (onGuardarModoCargaBDD){
            this.guardarRow(objetoNew, rowIndex, callback);
            return true;
        }
        else{
            //Comprobamos que estén todos los campos obligatorios rellenos:
            if (validarEntidad(elementoConfig, objetoNew)) {
                //console.log("validada");
                this.guardarRow(objetoNew, rowIndex, callback);
                return true;
            }
            else{
                //console.log("no validada");
                return false;
            }
         }

    }

    guardarRow= (elemento, rowIndex, callback) => {
        const {elementoConfig, onAntesGuardar, usuario, onDespuesGuardarElemento, onGuardarModoCargaBDD} = this.props;
        const {datos} = this.state;

        console.log("FORMULARIOGRID GUARDARROW");
        console.log("Elemento: ",elemento);
        console.log("usuario: ", usuario);


        if (onGuardarModoCargaBDD) {
            onGuardarModoCargaBDD(elemento, callback);
            return;
        }

        //Obtenemos el codigo de usuario
        let usuarioCodigo= usuario ? usuario.codigo : 0;

        //Eliminamos los campos artificiales
        let elementoPreparado= {...elemento};
        delete elementoPreparado.nivel;
        delete elementoPreparado.modificado;
        delete elementoPreparado.guardado;
        delete elementoPreparado.estadoRow;
        delete elementoPreparado.filaSeleccionada;
        delete elementoPreparado.rowIdx;
        if (onAntesGuardar) {
            elementoPreparado = onAntesGuardar(elementoPreparado);
        }

        let nuevo= elementoPreparado.codigo == 0;

        if (elementoConfig.url && elementoConfig.className){
            let urlPost= elementoConfig.url + elementoConfig.className + "/" + usuarioCodigo;;
            const clienteRestful = new ClienteRestful().setUrl(urlPost);

            clienteRestful.doPost(elementoPreparado, response => {
                if (clienteRestful.exito && response) {
                    console.log("INSERCION REALIZADA");
                    if(nuevo){
                        //datos[datos.length-1]=response;
                        datos.push(response);
                        this.setState({datos: datos}, () => {
                            callback(response, rowIndex, true);
                        });
                    }
                    else {
                        //sustituir el row;
                        let pos= posPrimerElementoConValorPropiedad(datos, "codigo", elementoPreparado.codigo);
                        datos[pos]= response;
                        callback(response, rowIndex, true);
                    }

                    //Nuevo
                    onDespuesGuardarElemento && onDespuesGuardarElemento(elementoPreparado);

                }
                else{
                    callback(response, rowIndex, false);
                }
            });
        }

    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    renderTabs= () => {
        const {selectedTab, gridConfig, datos, numPaginas, cargandoDatos, datosBusqueda, paginaActual,
            elementoSeleccionado,
            listasElementosCombos, cargandoListasElementosCombos,
            modoMostrarDatos } =  this.state;
        const {id, onValorBuscadorCambiado, valorBuscador, onNuevoElemento, elementoConfig, usuario, onDatosModificados,
            mostrarConmutadorModoMostrarDatos,
            childTablaFlex, usarFiltros35, gridAviso,
            childrenFormulariogrid} = this.props;

        let mostrarAcciones= true;
        if (typeof gridConfig.showAllAcciones === 'boolean' && gridConfig.showAllAcciones === false) {
            if (gridConfig.showAcciones.length === 0 && !gridConfig.botonesAdicionales)
                mostrarAcciones = false;
        }

        //console.log("FormularioGrid - RenderTabs:  ", id);
        //console.log("selectedTab: ", selectedTab);
        //console.log("typeof gridConfig.showAllAcciones: ", typeof gridConfig.showAllAcciones);
        //console.log("gridConfig.showAllAcciones: ", gridConfig.showAllAcciones);
        //console.log("gridConfig.showAcciones.length: ", gridConfig.showAcciones.length);
        //console.log("MOSTRAR ACCIONES, ", mostrarAcciones);

        let showPaginador= gridConfig.url !== undefined && gridConfig.className !== undefined;


        let tituloTabDatos= selectedTab === "datos" ? (<><Icon icon="paperclip"/> Datos </>) : (<><Icon icon="paperclip"/> Datos- F2 </>);
        let tituloBusqueda= selectedTab === "busqueda" ? (<><Icon icon="search"/> Búsqueda </>) : (<><Icon icon="search"/> Búsqueda - F2 </>);



        //console.log("valorBuscador: ", valorBuscador);
        //console.log("gridConfig.columnas: ", gridConfig.columnas);
        //console.log("datos: ", datos);
        //console.log("gridAviso: ", gridAviso);
        //console.log("ifid: ", gridConfig.ifid);
        //console.log("usuario: ", usuario);
        //console.log("childTablaFlex:");
        //console.log(childTablaFlex);
        //console.log("elementoSeleccionado:");
        //console.log(elementoSeleccionado);
        //console.log("Numpáginas: ", numPaginas)
        //console.log("mostrarAcciones: ", mostrarAcciones);
        //console.log("datosBusqueda: ", datosBusqueda);

        let elementosPorPagina=  gridConfig.elementosPorPagina;
        if (modoMostrarDatos == MODO_MOSTRARDATOS_TABLA)
            elementosPorPagina= gridConfig.elementosPorPaginaTabla;

        return (
            <>
            <KeyboardEventHandler
                handleKeys={['f2']}
                onKeyEvent={this.onFBuscar}/>
                <KeyboardEventHandler
                    handleKeys={['f2']}
                    onKeyEvent={this.onFBuscar}>
                <Tabs id="Tabs"
                     onChange={this.onChangeTab}
                     selectedTabId={selectedTab}
                     animate={true}
                     renderActiveTabPanelOnly={false}
                     vertical={false}>

                     <Tab id="datos" title= {tituloTabDatos}
                        panel={
                         <>
                             {modoMostrarDatos == MODO_MOSTRARDATOS_GRID &&
                             <GridPaginado id={id}
                                           tipoGrid={ gridConfig.tipoGrid}
                                           columnas={gridConfig.columnas}
                                           elementoConfig={elementoConfig}
                                           nivel={gridConfig.nivel}
                                           elementosPorPagina= {elementosPorPagina}
                                           numPaginas={numPaginas}
                                           onPageChanged={this.onPageChanged}
                                           datos={datos}
                                           onSelectedRow={this.onSelectedRow}
                                           onDeleteRow={this.onDeleteRow}
                                           ordenable={true}
                                           cargandoDatos={cargandoDatos}
                                           showPaginador={showPaginador}
                                           paginaActual={paginaActual}
                                           loadedTodasPaginas={gridConfig.loadTodasPaginas ? true : false}
                                           showBuscador={gridConfig.showBuscador}
                                           elementoSeleccionado={elementoSeleccionado}
                                           valorBuscador={valorBuscador}
                                           onValorBuscadorCambiado= {onValorBuscadorCambiado}
                                           editable={gridConfig.editable}
                                           onRowModificada={this.onRowModificada}
                                           onNewRow={onNuevoElemento}
                                           ifid={gridConfig.ifid}
                                           //usuarioCodigo={this.props.usuarioCodigo}

                                           onDatosModificados= {onDatosModificados}

                                           listasElementosCombos={listasElementosCombos}
                                           cargandoListasElementosCombos={cargandoListasElementosCombos}
                                           ref={this.refGridPaginado}
                                           usuario={usuario}

                                           mostrarFilaActiva={gridConfig.mostrarFilaActiva != undefined ? gridConfig.mostrarFilaActiva : true }
                                           estilizadorRow={gridConfig.estilizadorRow}
                                           estilo={gridConfig.estilo}

                                           paginacionTipo={gridConfig.paginacionTipo}
                                           urlServicioRestful={gridConfig.urlServicioRestful}
                                           usarFiltros35={usarFiltros35}
                                           aviso={gridAviso}
                                           funcRefreshData={this.onRefreshData}

                                           mostrarModificar= {gridConfig.mostrarModificar}
                                           onModificar={this.onAccion}
                                           mostrarEliminar= {gridConfig.mostrarEliminar}
                                           onEliminar={this.onAccion}

                                           mostrarChecksSeleccion={gridConfig.mostrarChecksSeleccion}
                                           onSelectedRowsChanged={this.onSelectedRowsChanged}
                             />
                             }
                             {modoMostrarDatos == MODO_MOSTRARDATOS_TABLA &&
                             <TablaFlexPaginada
                                 datos={datos} cargandoDatos={cargandoDatos}
                                 //numElementosOpcionesCadena={articulosFilasPagina ? articulosFilasPagina : numElementosOpcionesCadena}
                                 numElementosPorPaginaInicial={gridConfig.elementosPorPaginaTabla}
                                 numPaginas={numPaginas} onRefreshData={this.onRefreshData}
                                 onCeldaClick={this.onCeldaClick}
                                 onCeldaDobleClick={this.onCeldaDobleClick}
                                 elementoSeleccionado={elementoSeleccionado}

                             >
                                 {childTablaFlex}
                             </TablaFlexPaginada>
                             }

                             { //!gridConfig.editable && mostrarAcciones && ##Nuevo
                                 mostrarAcciones &&
                                 <FormularioBotonera
                                     numElementos={datos ? datos.length : 0}
                                     showAcciones={gridConfig.showAcciones}
                                     onAccion={this.onAccion}
                                     elementoSeleccionado={elementoSeleccionado}
                                     botonesAdicionales={gridConfig.botonesAdicionales}
                                     onBotonAdicionalClick={this.onBotonAdicionalClick}
                                     onGridConfigurarClick={this.onGridConfigurarClick}

                                     mostrarConmutadorModoMostrarDatos={mostrarConmutadorModoMostrarDatos}
                                     modoMostrarDatos= {modoMostrarDatos}
                                     onConmutarModoMostrarDatos={this.conmutarModoMostrarDatos}
                                     mostrarGridConfigurar={ gridConfig.mostrarGridConfigurar}
                                 />
                             }

                             {childrenFormulariogrid &&
                             childrenFormulariogrid.map((child, index) => {
                                 return (child)
                                })
                             }
                         </>
                     }/>

                    <Tab id="busqueda" title={tituloBusqueda}
                         panel={
                             <FormularioGridBusqueda busquedaCampos={gridConfig.busquedaCampos}
                                                     datosBusqueda={datosBusqueda}
                                                     urlServicioRestful={gridConfig.url}
                                                     onBuscar={this.onBuscar} onChangeFiltro={this.onChangeFiltro}
                                                     ref={this.refFormularioGridBusqueda}/>
                         }/>

                    <Tabs.Expander />
                </Tabs>
                </KeyboardEventHandler>
            </>

        );
    }

    renderOnlyGrid= () => {
        const {gridConfig, datos, numPaginas, cargandoDatos, paginaActual, elementoSeleccionado,
            listasElementosCombos, cargandoListasElementosCombos} =  this.state;
        const {id, onValorBuscadorCambiado, valorBuscador, onNuevoElemento, elementoConfig, usuario, onDatosModificados,
            modoMostrarDatos, usarFiltros35, gridAviso, childrenFormulariogrid,
            desdeMovil, childrenFormulariogridPre} = this.props;
        let mostrarAcciones= true;
        if (typeof gridConfig.showAllAcciones === 'boolean' && gridConfig.showAllAcciones === false) {
            if (!gridConfig.showAcciones || gridConfig.showAcciones.length === 0)
                mostrarAcciones = false;
        }

        console.log("<<<<< FormularioGrid - RenderOnlyGrid:  ", id);
        console.log("gridConfig: ", gridConfig);
        //console.log("typeof gridConfig.showAllAcciones: ", typeof gridConfig.showAllAcciones);
        //console.log("gridConfig.showAllAcciones: ", gridConfig.showAllAcciones);
        //console.log("gridConfig.showAcciones.length: ", gridConfig.showAcciones.length);
        //console.log("MOSTRAR ACCIONES, ", mostrarAcciones);
        //console.log("valorBuscador: ", valorBuscador);

        let showPaginador= gridConfig.url && gridConfig.className;
        return (
            <>
                {childrenFormulariogridPre &&
                    childrenFormulariogridPre.map((child, index) => {
                        return (child)
                    })
                }
                <GridPaginado  id={id}
                               tipoGrid={gridConfig.tipoGrid}
                               columnas={gridConfig.columnas}
                               elementoConfig={elementoConfig}
                               nivel={gridConfig.nivel}
                               elementosPorPagina= {gridConfig.elementosPorPagina}
                               numPaginas={numPaginas}
                               onPageChanged={this.onPageChanged}
                               datos={datos}
                               onSelectedRow={this.onSelectedRow}
                               ordenable={true}
                               cargandoDatos={cargandoDatos}
                               showPaginador={showPaginador}
                               paginaActual={paginaActual}
                               showBuscador={gridConfig.showBuscador}
                               elementoSeleccionado={elementoSeleccionado}
                               valorBuscador={valorBuscador}
                               onValorBuscadorCambiado= {onValorBuscadorCambiado}
                               editable={gridConfig.editable}
                               onRowModificada={this.onRowModificada}
                               onNewRow={onNuevoElemento}
                               //usuarioCodigo={this.props.usuarioCodigo}
                               onDatosModificados= {onDatosModificados}

                               listasElementosCombos={listasElementosCombos}
                               cargandoListasElementosCombos={cargandoListasElementosCombos}
                               ifid={gridConfig.ifid}
                               ref={this.refGridPaginado}
                               usuario={usuario}

                               mostrarFilaActiva={gridConfig.mostrarFilaActiva != undefined ? gridConfig.mostrarFilaActiva : true }
                               estilizadorRow={gridConfig.estilizadorRow}
                               modoMostrarDatos= {modoMostrarDatos}
                               estilo={gridConfig.estilo}

                               urlServicioRestful={gridConfig.urlServicioRestful}
                               usarFiltros35={usarFiltros35}
                               aviso={gridAviso}
                               funcRefresh={this.onRefreshData}

                               mostrarModificar={gridConfig.mostrarModificar}
                               onModificar={this.onAccion}
                               mostrarEliminar= {gridConfig.mostrarEliminar}
                               onEliminar={this.onAccion}

                               desdeMovil={desdeMovil}

                               mostrarChecksSeleccion={gridConfig.mostrarChecksSeleccion}
                               onSelectedRowsChanged={this.onSelectedRowsChanged}
                />

                {  /*!gridConfig.editable &&*/ mostrarAcciones &&
                    <FormularioBotonera
                        numElementos={datos ? datos.length : 0}
                        showAcciones={gridConfig.showAcciones}
                        onAccion={this.onAccion}
                        elementoSeleccionado={elementoSeleccionado}
                        botonesAdicionales={gridConfig.botonesAdicionales}
                        onBotonAdicionalClick={this.onBotonAdicionalClick}
                        onGridConfigurarClick={this.onGridConfigurarClick}
                        onConmutarModoMostrarDatos={(newModoMostrarDatos) => this.setState({modoMostrarDatos: newModoMostrarDatos})}
                    />
                }

                {childrenFormulariogrid &&
                childrenFormulariogrid.map((child, index) => {
                    return (child)
                    })
                }
            </>
        );
    }

    render() {
        const {gridConfig} = this.state;
        const {showBusqueda} = this.props;
        let mostrarBusqueda= true;
        if(typeof showBusqueda === 'boolean' && showBusqueda === false) {
            mostrarBusqueda= false;
        }
        else{
            if (gridConfig.busquedaCampos && gridConfig.busquedaCampos.length > 0)
                mostrarBusqueda= true;
            else
                mostrarBusqueda= false;
        }

        if (mostrarBusqueda === true)
            return this.renderTabs();
        else
            return this.renderOnlyGrid();
    }
}

/*
<ProyectoTablaCeldaImagen/>
 */

FormularioGrid.propTypes = {
    id: PropTypes.string,
    gridConfig: PropTypes.object.isRequired,
    llamadoDesdeOtroFormulario: PropTypes.bool,
    elementoConfig: PropTypes.object,
    onElementoSeleccionado: PropTypes.func,
    onDatosCargados: PropTypes.func,
    onModificarDatosCargados: PropTypes.func,
    showAcciones: PropTypes.array,
    showAllAcciones: PropTypes.bool,
    titulo: PropTypes.string,
    showBusqueda: PropTypes.bool,
    paginaActual: PropTypes.number,
    onPageChanged: PropTypes.func,
    onDatosBusquedaChanged: PropTypes.func, //Necesario para poder pasar los datos iniciales de busqueda  a FormularioGridBusqueda
    onFiltroBusquedaChanged: PropTypes.func, //Necesarios para reactivar la misma búsqueda al volver de modificar un elemento
    nombreSvg: PropTypes.string,
    empresa: PropTypes.object,
    pdfConfig: PropTypes.object,
    datosBusqueda: PropTypes.object,
    infoDatosInicial: PropTypes.object,
    elementoSeleccionado: PropTypes.object,
    valorBuscador: PropTypes.string,
    onValorBuscadorCambiado: PropTypes.func,
    onAntesCargarDatos: PropTypes.func,
    //usuarioCodigo: PropTypes.number,
    onAntesGuardar: PropTypes.func,
    onGuardarModoCargaBDD: PropTypes.func,
    onNuevoElemento: PropTypes.func,
    usuario: PropTypes.object,

    onDatosModificados: PropTypes.func,

    mostrarConmutadorModoMostrarDatos: PropTypes.bool,
    modoMostrarDatos: PropTypes.number,
    onConmutarModoMostrarDatos: PropTypes.func,
    onDobleClickCelda: PropTypes.func,
    usarFiltros35: PropTypes.bool,
    gridAviso: PropTypes.string,

    childrenFormulariogrid: PropTypes.array,
    childrenFormulariogridPre: PropTypes.array,

    onDespuesGuardarElemento: PropTypes.func,
    desdeMovil: PropTypes.bool,

    onSelectedRowsChanged: PropTypes.func,

}

export default FormularioGrid
